export default function (app) {
  app.controller('klLanguageController', [
    '$scope',
    'klTranslationService',
    function ($scope, TranslationService) {
      let ctrl = this;

      ctrl.setLanguage = TranslationService.setLanguage;
      ctrl.getLanguage = TranslationService.getLanguage;
      ctrl.getLanguageLabel = function () {
        return 'language_' + ctrl.getLanguage();
      };
    },
  ]);
}
